import React from 'react';
import { formatTraffic } from '../../utils/format';

const TunnelsTable = ({ tunnels }) => {
  if (!tunnels || tunnels.length === 0) {
    return (
      <tr>
        <td colSpan="3" className="py-6 text-center text-gray-500 dark:text-dark-500">
          Нет туннелей
        </td>
      </tr>
    );
  }

  return tunnels.map((tunnel, idx) => (
    <tr key={idx} className="border-b border-gray-100 dark:border-dark-800/50">
      <td className="py-2 px-3">
        <span className="font-medium text-gray-900 dark:text-white text-sm">{tunnel.name}</span>
      </td>
      <td className="py-2 px-3">
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
          tunnel.is_active
            ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-400'
        }`}>
          {tunnel.is_active ? 'Активен' : 'Офлайн'}
        </span>
      </td>
      <td className="py-2 px-3 text-right text-gray-600 dark:text-dark-400 text-sm">
        {formatTraffic((tunnel.traffic_gb || 0) * 1024)}
      </td>
    </tr>
  ));
};

export default TunnelsTable;
